import React from 'react';
import { TitleUnderline } from './icons';
import { Title, TitleItalic, TitleUnderlineWrap, TitleWordWrapper } from './styles';

const TrustpilotSectionTitle: React.FC = () => (
  <Title id="referral-trustpilot-title">
    <TitleWordWrapper>
      <TitleItalic>Real</TitleItalic>
      <TitleUnderlineWrap>
        <TitleUnderline />
      </TitleUnderlineWrap>
    </TitleWordWrapper>{' '}
    customers, real stories.
  </Title>
);

export default TrustpilotSectionTitle;
